import { cn } from "@ui/utils"
import { Check, Loader2 } from "lucide-react"

export function ArtifactSaveNotice({ state, className }: { state: "saving" | "saved"; className?: string }) {
  return (
    <span className={cn("flex items-center gap-1", state === "saved" && "text-green-accent", className)}>
      {state === "saving" ? <Loader2 className="size-3 animate-spin" /> : <Check className="size-3" />}
      {state === "saving" ? "Saving…" : "Saved"}
    </span>
  )
}
